function initSupapressFilters() {
    const {show_sub_subjects_dropdown_filters, show_sub_subjects_filters} = universityPressThemeSettings;
    const container = document.querySelector(".filter-load-wrapper");

    if( !container ) return;

    if( show_sub_subjects_dropdown_filters ) {
        document.addEventListener("click", (e) => {
            const li = e.target.closest(".filter-option");
            if( !li || li.parentElement.classList.contains('active') ) return;

            const aTag = li.querySelector("a");
            if( !aTag ) return;

            if( aTag.querySelector(".filter-option__sub-filter") ) return;

            e.preventDefault();

            const isOpen = li.classList.contains("open");

            container
                .querySelectorAll(".filter-option.open")
                .forEach((el) => el.classList.remove("open"));
            container
                .querySelectorAll(".filter-option__sub-filter")
                .forEach((el) => {
                    el.style.display = "none";
                    el.parentElement.style.display = 'inline';
                    el.parentElement.tabIndex = -1;
                });

            if( !isOpen ) {
                li.classList.add("open");

                let next = li.nextElementSibling;
                while( next ) {
                    const sub = next.querySelector(".filter-option__sub-filter");
                    if( !sub ) break;
                    sub.style.display = "block";
                    sub.parentElement.style.display = 'inline-block';
                    sub.parentElement.tabIndex = 0;
                    next = next.nextElementSibling;
                }
            }
        });
    }

    function getPreviousParentFilter(el) {
        let prev = el.previousElementSibling;

        while( prev ) {
            if( !prev.querySelector('.filter-option__sub-filter') && prev.querySelector('a') ) {
                return prev.querySelector('a');
            }
            prev = prev.previousElementSibling;
        }

        return null;
    }

    function unsetTabIndexForSubCats() {
        if( container.querySelectorAll(".additional-filters").length > 0 ) {
            setTimeout(function() {
                container.querySelectorAll(".additional-filters").forEach((filter) => {
                    const maxHeight = parseInt(getComputedStyle(filter).maxHeight, 10);
                    if( maxHeight === 0 ) {
                        filter.setAttribute("inert", "inert");
                    } else {
                        filter.removeAttribute("inert", "inert");
                        const prevElement = getPreviousParentFilter(filter);
                        prevElement.focus();
                    }
                });
            }, 1000);
        }

        if( container.querySelectorAll(".filter-option__sub-filter").length === 0 && !show_sub_subjects_filters || container.querySelectorAll("ul.active").length !== 0 ) return;

        container.querySelectorAll(".filter-option__sub-filter").forEach((filter) => {
            filter.parentElement.setAttribute("tabindex", "-1");
        });
    }


    function addCategoryBlockClass() {
        if( !show_sub_subjects_dropdown_filters ) return;

        container.querySelectorAll(".filter-block").forEach((block) => {
            const h3 = block.querySelector("h3");
            const hasSubFilter = block.querySelector(".filter-option__sub-filter");

            if( h3 && h3.textContent.trim() === "Category" && hasSubFilter ) {
                block.classList.add("category-block");
            }
        });
    }

    const observer = new MutationObserver((mutationsList) => {
        for( const mutation of mutationsList ) {
            if( mutation.addedNodes.length ) {
                addCategoryBlockClass();
                unsetTabIndexForSubCats();
            }
        }
    });

    observer.observe(container, {childList: true, subtree: true});
}

initSupapressFilters();
